import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): unknown {
    let formattedAddress = 'Address unavailable';

    if (value) {
      formattedAddress = (value.unit_type ? value.get_unit_type_display + ' ' : '') +
        (value.unit_number ? value.unit_number + ' ' : '') +
        (value.level_type ? value.get_level_type_display + ' ' : '') +
        (value.level_number ? value.level_number + ' ' : '') +
        (
          value.street_line ? value.street_line + ' ' :
          (
            value.street_number + ' ' + value.street_name + ' ' +
            (value.street_type ? value.get_street_type_display + ' ' : '')
          )
        ) +
        (
          value.suburb_obj ? (value.suburb_obj.suburb + ' ' + value.suburb_obj.state + ' ' + value.suburb_obj.postcode) :
            value.suburb + ' ' + value.state + ' ' + value.postcode
        );
    }

    return formattedAddress;
  }

}
